const Config = {
  appTitle: `${window.env.REACT_APP_TITLE}`,
  appVersion: `${window.env.REACT_APP_VERSION}`,
  baseUrl: `${window.env.REACT_APP_BASE_URL}`,
  filePath: `${window.env.REACT_FILE_PATH}`,
  socketPath: `${window.env.SOCKET_PATH}`,
  imagesPath: `${window.env.REACT_APP_IMAGES}`,
  appEnv: `${window.env.REACT_APP_ENV}`,
};
export default Config;
